import { render, staticRenderFns } from "./RecordFilter.vue?vue&type=template&id=0332a726&scoped=true"
import script from "./RecordFilter.vue?vue&type=script&lang=js"
export * from "./RecordFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0332a726",
  null
  
)

export default component.exports